// routes
import Router from "./routes";

// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
// components
import ScrollToTop from "./components/ScrollToTop";
import { BaseOptionChartStyle } from "./components/charts/BaseOptionChart";

import { useMemo } from "react";

import { sv as svLocale, enGB as enLocale, fr as frLocale } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { SnackbarProvider } from "notistack";
import { svSE, enUS, frFR } from "@mui/x-date-pickers/locales";

// Mui-x pro licensuppgifter
import { LicenseInfo } from "@mui/x-license";
LicenseInfo.setLicenseKey(
  "ced60a2f75903958204a1ad6fe1f775eTz0xMjgyMzksRT0xODA4MTc5MTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y",
);

// ----------------------------------------------------------------------

export default function App() {
  const locale = useMemo(() => {
    switch (localStorage.lang) {
      case "9":
        return enLocale;
      case "12":
        return frLocale;
      case "29":
      default:
        return svLocale;
    }
  }, []);

  const localeText = useMemo(() => {
    switch (localStorage.lang) {
      case "9":
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText; // enGB does not exist
      case "12":
        return frFR.components.MuiLocalizationProvider.defaultProps.localeText;
      case "29":
        return svSE.components.MuiLocalizationProvider.defaultProps.localeText;
      default:
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    }
  });

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale} localeText={localeText}>
        <SnackbarProvider>
          <Router />
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeConfig>
  );
}
